import { type Dispatch, type SetStateAction } from 'react';
import TaskExecutorFlags from '../../../shared/TaskExecutorFlags';
import TaskPayFields from '../../../shared/TaskPayFields';
import type { DirFormState } from '../../model/useOffTaskDir';

interface OffTaskDirAdditionalTabProps {
    form: DirFormState;
    setForm: Dispatch<SetStateAction<DirFormState>>;
    saving: boolean;
}

const OffTaskDirAdditionalTab = ({ form, setForm, saving }: OffTaskDirAdditionalTabProps) => {
    return (
        <>
            <TaskPayFields
                idPrefix="dir-task"
                disabled={saving}
                value={{
                    pay: form.pay,
                    payAmount: form.payAmount,
                    payUsd: form.payUsd,
                    showPayToExecutor: form.showPayToExecutor,
                }}
                onChange={(next) => setForm((prev) => ({ ...prev, ...next }))}
            />
            <TaskExecutorFlags
                idPrefix="dir-task"
                disabled={saving}
                value={{
                    reserveExecutorTime: form.reserveExecutorTime,
                    executorCanChangeTerm: form.executorCanChangeTerm,
                    noEarlyStart: form.noEarlyStart,
                }}
                onChange={(next) => setForm((prev) => ({ ...prev, ...next }))}
            />
        </>
    );
};

export default OffTaskDirAdditionalTab;
